<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select
        @changeDateFormatData="changeDateFormatData($event.dateFormatId)"
      />
      <el-input
        v-model="tableParams.oppoChannel"

        clearable
        placeholder="请输入渠道号"
        @input="removeBlank(tableParams.oppoChannel, 'oppoChannel')"
      />
      <el-input
        v-model="tableParams.appBundle"

        clearable
        placeholder="请输入应用包名"
        @input="removeBlank(tableParams.appBundle, 'appBundle')"
      />
      <el-input
        v-model="tableParams.appName"

        clearable
        placeholder="请输入应用名称"
        @input="removeBlank(tableParams.appName, 'appName')"
      />
      <search-dsp-select v-model="tableParams.dspId" />
      <el-input
        v-model="tableParams.keyword"

        clearable
        placeholder="请输入关键字（模糊）"
        @input="removeBlank(tableParams.keyword, 'keyword')"
      />
      <el-input
        v-model="tableParams.preciseKeyword"

        clearable
        placeholder="请输入关键字（精确）"
        @input="removeBlank(tableParams.preciseKeyword, 'preciseKeyword')"
      />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel(
              '/webReportKeyword/app/list/csv',
              '应用关键字报表',
              tableParams
            )
          "
          type="warning"
          size="small"
          >下载</el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column
          v-if="tableParams.showType > 0"
          prop="timeKey"
          :label="
            tableParams.showType === 2 || tableParams.showType === 4
              ? '日期'
              : '时间'
          "
          fixed
          sortable
          align="center"
        />
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
          :sortable="
            v.field === 'showSmt' ||
            v.field === 'timeKey' ||
            v.field === 'appBundle' ||
            v.field === 'keyword' ||
            v.field === 'contactPhone' ||
            v.field === 'hit' ||
            v.field === 'winPrice' ||
            v.field === 'auctionPrice' ||
            v.field === 'clkSmt' ||
            v.field === 'expensesEcpm' ||
            v.field === 'expensesAge' ||
            v.field === 'incomeEcpm' ||
            v.field === 'incomeAge' ||
            v.field === 'clkAvg' ||
            v.field === 'timeKey'
          "
        >
          <template v-slot="scope">
            <el-tag
              v-if="v.field === 'showRat' || v.field === 'clickRate'"
              type="info"
              >{{ scope.row[v.field] }}%</el-tag
            >
            <div
              v-else-if="v.field === 'configuration'"
              @click="oncli(scope.row)"
            >
              <span
                v-if="!scope.row.profitRate"
                style="color: #61b3d9; cursor: pointer"
                >配置</span
              >
              <span v-else style="color: #61b3d9; cursor: pointer">{{
                scope.row.profitRate
              }}</span>
            </div>
            <div
              v-else-if="v.field === 'auctionMiniPrice'"
              @click="oncli2(scope.row, 'expend')"
            >
              <span
                v-if="!scope.row.outLowPrice"
                style="color: #61b3d9; cursor: pointer"
                >配置</span
              >
              <span v-else style="color: #61b3d9; cursor: pointer">{{
                scope.row.outLowPrice
              }}</span>
            </div>
            <div
              v-else-if="v.field === 'winMiniPrice'"
              @click="oncli2(scope.row, 'income')"
            >
              <span
                v-if="!scope.row.inLowPrice"
                style="color: #61b3d9; cursor: pointer"
                >配置</span
              >
              <span v-else style="color: #61b3d9; cursor: pointer">{{
                scope.row.inLowPrice
              }}</span>
            </div>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <m-form ref="form1" title="利润率" />
      <m-form2 ref="form2" :title="type + '低价'" />

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
  </div>
</template>

<script>
import DateFormatSelect from '@/components/DateFormatSelect'
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import downExcelMixin from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import mForm from './form'
import mForm2 from './form2'

export default {
  name: 'Manage/keyword/appWord',
  components: {
    DateFormatSelect,
    TableColumn,
    SearchDspSelect,
    BaseDatePicker,
    mForm,
    mForm2
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: 'appBundle', title: '应用包名' },
        { field: 'appName', title: '应用名称' },
        { field: 'dspName', title: 'DSP名称' },
        { field: 'keyword', title: '关键字' },
        // { field: 'dspType', title: '请求数' },
        { field: 'hit', title: '命中数' },
        { field: 'showSmt', title: '展示数' },
        { field: 'showRat', title: '展示率' },
        { field: 'clkSmt', title: '点击数' },
        { field: 'clickRate', title: '点击率' },
        { field: 'expensesEcpm', title: '支出ecpm' },
        { field: 'auctionPrice', title: '支出' },
        { field: 'expensesAge', title: '支出均价' },
        { field: 'incomeEcpm', title: '收入ecpm' },
        { field: 'winPrice', title: '收入' },
        { field: 'incomeAge', title: '收入均价' },
        { field: 'configuration', title: '利润率设置' },
        { field: 'auctionMiniPrice', title: '设置支出低价' },
        { field: 'winMiniPrice', title: '设置收入低价' }
        // { field: 'contactPhone', title: '下载数' },
      ],
      type: '',
      tey: false
    }
  },
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  provide() {
    return {
      init: this.init
    }
  },
  methods: {
    beforeInit() {
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      this.tableUrl = '/webReportKeyword/app/list'
      return true
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    oncli(row) {
      this.$refs.form1.show(row)
    },
    oncli2(row, type) {
      this.type = type === 'expend' ? '支出' : '收入'
      this.$refs.form2.show(row, type)
    },
    sortChange(column, prop, order) {
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ''
      } else if (column.order === 'descending') {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ''
      }
      this.init()
    },
    sizeChange(e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange(e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    removeBlank(val, name) {
      this.tableParams[name] = val.replace(/^\s+|\s+$/gm, '')
    },
    changeDateFormatData (dateFormatId) {
      if (dateFormatId === 1) {
        // 日
        this.tableParams.showType = 1
      } else if (dateFormatId === 2) {
        // 时
        this.tableParams.showType = 2
      }
      else {
        // 正常
        this.tableParams.showType = 0
      }
      this.tableParams.asc = ''
      this.tableParams.desc = ''
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
